import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BANK_DETAIL_FEATURE_KEY, EpimsBankDetailState, EpimsBankDetailPartialState, bankDetailAdapter } from './bank-detail.reducer';

// Lookup the 'EpimsBankDetail' feature state managed by NgRx
export const getEpimsBankDetailState = createFeatureSelector<EpimsBankDetailPartialState, EpimsBankDetailState>(BANK_DETAIL_FEATURE_KEY);

const { selectAll, selectEntities } = bankDetailAdapter.getSelectors();

export const getEpimsBankDetailLoaded = createSelector(getEpimsBankDetailState, (state: EpimsBankDetailState) => state.loaded);

export const getEpimsBankDetailError = createSelector(getEpimsBankDetailState, (state: EpimsBankDetailState) => state.error);

export const loadingEpimsBankDetail = createSelector(getEpimsBankDetailState, (state: EpimsBankDetailState) => state.loaded);

export const getAllEpimsBankDetail = createSelector(getEpimsBankDetailState, (state: EpimsBankDetailState) => selectAll(state));

export const getEpimsBankDetailEntities = createSelector(getEpimsBankDetailState, (state: EpimsBankDetailState) => selectEntities(state));

export const getSelectedId = createSelector(getEpimsBankDetailState, (state: EpimsBankDetailState) => state.selectedEpimsBankDetailId);

export const getSelected = createSelector(
	getEpimsBankDetailEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
